import { animHelperFN } from '../lib/lib';

export default {
  'initial.dataset.marimekko': function () {
    var component = this,
      chart = component.getFromEnv('chart'),
      yDepth = chart.config.yDepth || 0,
      yAttrKey = 'y',
      hAttrKey = 'height',
      yAxis = component.getFromEnv('yAxis');
    return {
      'rect.appearing': function (inputJSON) {
        // appearing animation for the data plots.
        var zeroPos = yAxis.getPixel(yAxis.getAxisBase()) + (chart.isBar ? -yDepth : yDepth),
          actualFinalAttr = inputJSON.attr,
          yAttrVal,
          hAttrVal,
          yBasePos,
          endPosWRT0;

        // Store final y and h for later use
        yAttrVal = actualFinalAttr[yAttrKey];
        hAttrVal = actualFinalAttr[hAttrKey];
        endPosWRT0 = Math.sign(yAttrVal + (hAttrVal / 2) - zeroPos);
        yBasePos = yAttrVal + hAttrVal;
        return [{
          initialAttr: function () {
            var initialAttr = {};
            // Replace the y and h with initial positions
            initialAttr[yAttrKey] = yBasePos;
            initialAttr[hAttrKey] = 0;
            return initialAttr;
          },
          slot: 'plot',
          startEnd: function () {
            return animHelperFN.getTimeByValue({start: 0, end: 0.6},
              {
                startPx: zeroPos,
                endPx: endPosWRT0 === 1 ? component.config.yAxisMaxPixel : component.config.yAxisMinPixel
              }, {
                startPx: yBasePos,
                endPx: endPosWRT0 === 1 ? (actualFinalAttr[yAttrKey] +
                      actualFinalAttr[hAttrKey]) : actualFinalAttr[yAttrKey]
              });
          },
          effect: 'linear'
        }];
      },
      'group.appearing': null,
      'group.updating': null,
      'plotLabel.appearing': [{
        initialAttr: {
          opacity: 0
        },
        slot: 'final'
      }],
      '*': null
    };
  }
};
